//Based on https://stackoverflow.com/a/3620374
export const cssPath = (el?: Element | null): string => {
  if (!(el instanceof Element)) return '';
  const path = [];
  while (el && el.nodeType === Node.ELEMENT_NODE) {
    let selector = el.nodeName.toLowerCase();
    if (el.id) {
      selector += '#' + el.id;
    } else {
      let sib: Element | ChildNode | null = el;
      let nth = 1;
      while (
        sib.nodeType === Node.ELEMENT_NODE &&
        (sib = sib.previousSibling) &&
        nth++
      );
      selector += `:nth-child(${nth})`;
    }
    path.unshift(selector);
    //eslint-disable-next-line no-param-reassign
    el = el.parentNode as Element | null | undefined;
  }
  return path.join(' > ');
};
